"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var datapoints_1 = require("../../datapoints");
var owa_analytics_1 = require("owa-analytics");
var owa_mail_persona_search_folder_services_1 = require("owa-mail-persona-search-folder-services");
var owa_trace_1 = require("owa-trace");
/**
 * If the currenly selected persona get un-favorited we cannot delete the search folder
 * immediately, but once the selected node changes.
 */
function onSelectedPersonaNodeChanged(personaNode) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var error_1, _a, eventName, customData;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!personaNode.markedForDeletion) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_mail_persona_search_folder_services_1.deleteFolders([personaNode.searchFolderId], true /* permanentlyDelete */)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    _a = datapoints_1.default.DeleteFolderFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    owa_trace_1.trace.warn(eventName + ': ' + error_1);
                    owa_analytics_1.logUsage(eventName, customData(error_1.toString()));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.default = onSelectedPersonaNodeChanged;
//# sourceMappingURL=onSelectedPersonaNodeChanged.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/people/onSelectedPersonaNodeChanged.js
// module id = 4651
// module chunks = 14